import { ImgProps } from "assets/images/types";

export default function ImgKaiakSonarMain(props: ImgProps) {
	const { height = 258, width = 517 } = props;
	return (
		<img
			src="/assets/images/cases/kaiak-sonar/kaiak-sonar-card.webp"
			alt="Natura Kaiak Sonar"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
